// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1C6E5","footer":"Form_footer__2fxWL"};